export default __webpack_public_path__ + "static/media/portfolio.6c7818a6.jpg";